<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <div class="card-icon">
            <md-icon>textsms</md-icon>
          </div>
          <h4 class="title">
            Enquiry
          </h4>
        </md-card-header>
        <md-card-content>
          <div v-if="enquiry" class="md-layout">
            <traveller-info
              :enquiry="enquiry"
              @outcomeDialog="manageOutcome"
              @reactivateEnquiry="reactivateEnquiry"
            ></traveller-info>

            <div class="md-layout-item md-size-40">
              <h6>Enquiry Info</h6>
              <enquiry-info :enquiry="enquiry"></enquiry-info>
            </div>

            <div class="md-layout-item md-size-60">
              <md-toolbar md-elevation="0" class="md-transparent md-dense">
                <div class="md-toolbar-section-start">
                  <h6>Interactions</h6>
                </div>
                <div class="md-toolbar-section-end">
                  <md-button
                    class="md-icon-button md-dense md-primary md-round"
                    @click="showInteractionDialog"
                  >
                    <md-icon>add</md-icon>
                    <md-tooltip md-direction="top"
                      >Add an Interaction</md-tooltip
                    >
                  </md-button>
                </div>
              </md-toolbar>

              <div
                v-for="interaction in enquiry.interactions"
                :key="interaction.id"
              >
                <interaction-item
                  :interaction="interaction"
                  @deleteInteraction="deleteInteraction"
                  @editInteraction="editInteraction"
                />
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <enquiry-interaction-dialog
        :showDialog="showDialog"
        :enquiry="enquiry"
        :interaction="selectedInteraction"
        @cancel="cancel"
        @update="update"
      />

      <enquiry-outcome-dialog
        :showDialog="showOutcomeDialog"
        :enquiry="enquiry"
        @cancel="cancelOutcome"
        @update="updateOutcome"
      />
    </div>
  </div>
</template>

<script>
import enquiryApi from "@/services/api/enquiry";
import _filter from "lodash/filter";
import _findIndex from "lodash/findIndex";

import EnquiryInfo from "./EnquiryInfo.vue";
import InteractionItem from "./InteractionItem.vue";
import TravellerInfo from "./TravellerInfo.vue";
import EnquiryInteractionDialog from "./EnquiryInteractionDialog.vue";
import EnquiryOutcomeDialog from "./EnquiryOutcomeDialog.vue";

export default {
  props: ["id"],

  data() {
    return {
      enquiry: null,
      showDialog: false,
      showOutcomeDialog: false,
      selectedInteraction: {}
    };
  },

  components: {
    EnquiryInfo,
    TravellerInfo,
    InteractionItem,
    EnquiryInteractionDialog,
    EnquiryOutcomeDialog
  },

  methods: {
    getEnquiry(id) {
      enquiryApi.getEnquiry(id).then(response => {
        this.enquiry = response.data;
      });
    },

    reset() {
      this.selectedInteraction = {
        id: null,
        content: null,
        type: { value: null },
        direction: { value: "incoming" }
      };
    },

    showInteractionDialog() {
      this.reset();
      this.showDialog = true;
    },

    editInteraction(interaction) {
      this.selectedInteraction = interaction;
      this.showDialog = true;
    },

    deleteInteraction(interaction) {
      let args = {
        enquiry: this.enquiry,
        interaction: interaction
      };
      enquiryApi.deleteInteraction(args).then(response => {
        this.enquiry.interactions = _filter(this.enquiry.interactions, function(
          item
        ) {
          return item.id !== interaction.id;
        });

        this.$notify({
          timeout: 2500,
          message: "Deleted.",
          icon: "cancel",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger"
        });
      });
    },

    cancel() {
      this.reset();
      this.showDialog = false;
    },

    update(updateInfo) {
      if (updateInfo.mode == "CREATE") {
        this.enquiry.interactions.unshift(updateInfo.interaction);
      } else {
        var index = _findIndex(this.enquiry.interactions, {
          id: updateInfo.interaction.id
        });
        this.enquiry.interactions.splice(index, 1, updateInfo.interaction);
      }

      this.showDialog = false;
      this.reset();
    },

    reactivateEnquiry() {
      enquiryApi.reactivateEnquiry(this.enquiry).then(response => {
        this.enquiry = response.data;
      });
    },

    manageOutcome() {
      this.showOutcomeDialog = true;
    },

    updateOutcome(updateInfo) {
      this.showOutcomeDialog = false;
      this.getEnquiry(this.enquiry.id);
    },

    cancelOutcome() {
      this.showOutcomeDialog = false;
    }
  },

  watch: {
    "$route.params.id": function(id) {
      this.getEnquiry(id);
    }
  },

  created() {
    this.getEnquiry(this.id);
  }
};
</script>
<style lang="scss" scoped></style>
